import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=6538e3a6&scoped=true"
import script from "./TextEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=6538e3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_lodash@4.17.21_prettier@2.8.8_vue-template-compiler@2.7.14_webpack@5.80.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6538e3a6",
  null
  
)

export default component.exports